<template>
  <div>
    <router-view/>
    <div data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-duration="1000">
      <Contact />
    </div>
    <div>
      <go-top
        :has-outline="false"
        :right="25"
        :size="60"
        :radius="26"
        bg-color="#090739"
      >
      </go-top>
    </div>
  </div>
</template>

<script>
import Contact from './components/Contact';
import GoTop from '@inotom/vue-go-top';

export default {
  name: 'App',
  components: {
    Contact,
    GoTop
  }
}
</script>
<style>
.app {
  z-index: 0;
  overflow: hidden;
}
</style>

